export default __webpack_public_path__ + "static/media/donut.c8c17120.svg";